import React , {Component} from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import {fetchPropertyType } from '../../api/kugi';
import _ from 'lodash';
import Collapse from '@material-ui/core/Collapse';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import { css } from "@emotion/core";
import {BarLoader} from "react-spinners";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

const override = css`
position: absolute;
  top: 50%;
  left: 45%;
  margin: 0 auto;
`;



const theme = createMuiTheme({
  overrides: {
    MuiTableCell: {
      root: {
        paddingTop: 4,
        paddingBottom: 4,
        "&:last-child": {
          paddingRight: 5
        }
      }
    }
  }
});

class TablePropertyType extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selectedUnsur: "",
      code: this.props.code,
      fcid: this.props.fcid,
      propertyType: [],
      propertyAll: [],
      loading: true
    }
  }

  componentWillMount(){

    fetchPropertyType(this.state.fcid, this.state.code)
      .then(response => {
        this.setState({loading:false});
        let prop = [];
        response.data.map((e)=>{
          let aa = e.lvCodeDetail.replace("@en", "");

          let lvcd = parseInt(aa);
          if(isNaN(lvcd) == true){
            lvcd = "tidak ada list value";
          }

          prop.push({
            cardinality: e.cardinality,
            code:e.code, lvCode:e.lvCode,
            lvCodeDetail:lvcd,
            lvLabel:e.lvLabel,
            memberName:e.memberName,
            ptDefinition:e.ptDefinition,
            faCode:e.faCode,
            faValueMeasurementUnit:e.faValueMeasurementUnit,
            faValueType:e.faValueType,
            fcDefinitionReference1:e.fcDefinitionReference1,
            fcProducer1:e.fcProducer1,
            bfAtribute:e.bfAtribute,
            kode:e.kode,
            fcConstraint:e.fcConstraint
          })
        });

        let b = _.orderBy(prop, ['lvCodeDetail'], ['asc']);
         this.setState({propertyType: _.uniqBy(prop, 'memberName'), propertyAll: b});
      })
      .catch(error => {
        console.log(error);
      });
  }

  renderLV = (e) => {
    return (
      <span>{e.lvCode.replace("@en", "")}</span>
    )
  }

  renderProps = (e) => {

    if(e.lvLabel.replace("@en", "") !== "-"){
      return (

          <TableRow>
            <TableCell >{e.lvLabel.replace("@en", "")}</TableCell>
            <TableCell >{e.lvCodeDetail}</TableCell>
            <TableCell >{e.lvCode.replace("@en", "")}</TableCell>
          </TableRow>
      )
    }else{
      return <TableRow/>
    }

  }





  renderProperty = (e) => {
    let eachLV = _.filter(this.state.propertyAll, {memberName: e.memberName});

    let uniq = _.uniqBy(eachLV, function(o){
        return o.lvCode;
    });

    console.log(e);

    return (

      <ExpansionPanel>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >

          <Table  aria-label="simple table">
            <TableHead>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%",  padding: 2}}>Nama Atribut</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%",  bgColor:"#969199", padding: 2}}>Definisi Atribut</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%",  padding: 2}}>List Value Code</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", padding: 0}}>{e.memberName.replace("@en", "")}</TableCell>
                <TableCell style = {{borderBottom: "none", padding: 0}}>{e.ptDefinition.replace("@en", "")}</TableCell>
                <TableCell style = {{borderBottom: "none", padding: 0}}> {uniq.map(this.renderLV)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <hr/>

        </ExpansionPanelSummary>
        <ExpansionPanelDetails>

        <Grid container spacing={3}>
          <Grid item xs={12}>
          <Table  aria-label="simple table">
            <TableBody>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Kode Atribut</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.faCode.replace("@en", "")}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Satuan Atribut</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.faValueMeasurementUnit.replace("@en", "")}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Jenis Satuan Atribut</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.faValueType.replace("@en", "")}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Referensi Definisi Atribut</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.fcDefinitionReference1.replace("@en", "")}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Produsen</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.fcProducer1.replace("@en", "")}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Pembatasan</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.fcConstraint.replace("@en", "")}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
              <TableRow style={{height: 1}}>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}><b>Bound Feature Atribute</b></TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}>{e.bfAtribute.replace("@en", "")}</TableCell>
                <TableCell style = {{borderBottom: "none", width:"10%", padding: 2}}/>
              </TableRow>
            </TableBody>

          </Table>
          </Grid>

          <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table  aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>List Value Label</TableCell>
                  <TableCell>List Value Code Detail</TableCell>
                  <TableCell>List Value Code</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {_.filter(this.state.propertyAll, {memberName: e.memberName}).map(this.renderProps)}
              </TableBody>
            </Table>
          </TableContainer>
          </Grid>
        </Grid>

        </ExpansionPanelDetails>
      </ExpansionPanel>

    )
  }

  render(){
    return (
     <Paper>
       <div className="sweet-loading">
         <BarLoader
           css={override}
           height={4}
           width={300}
           color={"#E8EAF6"}
           loading={this.state.loading}
         />
       </div>
        <p style={{padding:10}}><b>Property Type :</b></p>
        {this.state.propertyType.map(this.renderProperty)}
      </Paper>
    )
  }
}

const mapStatetoProps = state => {

    return {
        unsurSelected: state.unsurSelected
    };
}


export default connect(mapStatetoProps)(TablePropertyType);
